import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import {
  MatDatepickerModule,
  MatDateRangePicker,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { EmployeeStore } from '@modules/job/details/resources/employee.store';
import { JobResourceTypeStore } from '@modules/job/details/resources/job-resource-type.store';

import { OverviewFilters } from '../overview.service';
import { OverviewStore } from '../overview.store';
import { MonthPickerComponent } from './pickers/month-picker/month-picker.component';
import { QuarterlyPickerComponent } from './pickers/quarterly-picker/quarterly-picker.component';
import { WeekPickerComponent } from './pickers/week-picker/week-picker.component';
import { YearPickerComponent } from './pickers/year-picker/year-picker.component';

type DatePickerType = 'custom' | 'week' | 'month' | 'quarter' | 'year';

@Component({
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    WeekPickerComponent,
    MonthPickerComponent,
    YearPickerComponent,
    QuarterlyPickerComponent,
    MatButtonToggleModule,
  ],
  selector: 'norupe-overview-sidemenu',
  styles: ``,
  templateUrl: './overview-sidemenu.component.html',
})
export class OverviewSidemenuComponent {
  private overviewStore = inject(OverviewStore);

  public employeeStore = inject(EmployeeStore);
  public resourceTypeStore = inject(JobResourceTypeStore);
  readonly formBuilder = inject(FormBuilder);

  filterForm = this.formBuilder.group({
    assignedTo: this.formBuilder.control<number[]>([]),
    endDate: this.formBuilder.control<Date | null>(null),
    startDate: this.formBuilder.control<Date | null>(null),
    type: this.formBuilder.control<number[]>([]),
  });

  selectedPickerType: DatePickerType = 'custom';
  onPickerTypeChange(type: DatePickerType) {
    this.selectedPickerType = type;

    //reset dates
    this.filterForm.patchValue({
      endDate: null,
      startDate: null,
    });
  }

  onEndDateSelected(date: Date | null) {
    this.filterForm.patchValue({
      endDate: date,
    });
  }
  onStartDateSelected(date: Date | null) {
    this.filterForm.patchValue({
      startDate: date,
    });
  }

  clearDate(picker: MatDateRangePicker<Date | null>) {
    picker.select(null);
  }

  loadOverview() {
    if (!this.filterForm.valid) {
      return;
    }

    const filters: OverviewFilters = {
      assignedTo: this.filterForm.value.assignedTo ?? [],
      endDate: this.filterForm.value.endDate ?? null,
      startDate: this.filterForm.value.startDate ?? null,
      type: this.filterForm.value.type ?? [],
    };

    this.overviewStore.resetPagination();
    this.overviewStore.loadOverview(filters);
  }
}
